import { JobBean }  from './job.bean';

export class PositionJobBean extends JobBean{
    constructor (){
        super()
        this.param={itens:[]}
    }
    public associateJob(writData){       

    }
    public testJob(writTest,job,wrt){
              //need to test all checks and see if all is ok or not
              if (writTest.triggerKind!='onSuccess'){
                return;
              }

              let objectTested=writTest.entity.id;

              let allOk=true;
              job.myPoint=0;
              job.param.itens.forEach(it=>{
                if (!it.completed){
                  if (it.objectId==objectTested){
                    it.completed=true;
                    job.myPoint=job.myPoint+job.actionPt
                  }
                  else{
                    allOk=false
                  }
                }
                else{
                  job.myPoint=job.myPoint+job.actionPt
                }
              })

              if (allOk){
                wrt.jobs[writTest.job].completed=true;
                let date=new Date();
                wrt.jobs[writTest.job].dateEnd=date.getTime();   
                this._companyService.getUserWrit(this._appData.instagramUser,writTest.group.toString()).set(wrt).then(val=>{})
                job.success=true          
                return true
              }             
              else{
                job.success=false;
                wrt.jobs[writTest.job]=job;
                this._companyService.getUserWrit(this._appData.instagramUser,writTest.group.toString()).set(wrt).then(val=>{})
                return false;
              }

    }
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/beansts/quests/PositionJob.ts